
import { TextInput } from "@mantine/core";
import { Controller, useFormContext } from "react-hook-form";

const RHFNumberInput = ({
  name,
  rules,
  defaultValue = "",

  maxLength,
  allowDecimal = false,
  allowNegative = false,

  min,
  max,

  onValueChange,

  ...props
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => {
        const handleChange = (event) => {
          let value = event.currentTarget.value;

          // Allow numbers / decimal / negative
          if (allowDecimal) {
            value = value.replace(
              allowNegative ? /[^0-9.-]/g : /[^0-9.]/g,
              ""
            );

            const parts = value.split(".");
            if (parts.length > 2) {
              value = parts.shift() + "." + parts.join("");
            }
          } else {
            value = value.replace(
              allowNegative ? /[^0-9-]/g : /[^0-9]/g,
              ""
            );
          }

          // Only one minus sign
          if (allowNegative) {
            value = value.replace(/(?!^)-/g, "");
          }

          if (maxLength) {
            value = value.slice(0, maxLength);
          }

          // Min / Max Validation
          if (value !== "" && !isNaN(value)) {
            const number = Number(value);

            if (min !== undefined && number < min) {
              value = String(min);
            }

            if (max !== undefined && number > max) {
              value = String(max);
            }
          }

          field.onChange(value);

          if (onValueChange) {
            onValueChange(value);
          }
        };

        return (
          <TextInput
            {...props}
            {...field}
            value={field.value ?? ""}
            error={error?.message}
            inputMode={allowDecimal ? "decimal" : "numeric"}
            onChange={handleChange}
             styles={{
                          label: {
                          fontSize: "16px",lineHeight: "24px",fontWeight: 400,color: "#222222",marginBottom:'8px'
                        }}}
          />
        );
      }}
    />
  );
};

export default RHFNumberInput;